import React, { Component } from 'react';
import { Tile, ListItem } from '../../components';

class SearchResultsTiles extends Component {

  render() {
    if (this.props.items.length < 1) {
      return (
        <ListItem
          disabled
          primaryText={'Keine Suchergebnisse'}
          secondaryText={`Leider konnten wir keine ${this.props.type} für gewählten Suchbegriff finden`}
          secondaryTextLines={2}
        />);
    }

    return (
      <div>
        {this.props.items.map((item, i) =>
          <Tile
            className={'tile'}
            key={i}
            title={item.name}
            onClick={() => this.props.onClick(item)}
            imageUrl={item.imageUrl}
            progress={item.progress}
          />)}
      </div>
    );
  }
}

export default SearchResultsTiles;



// WEBPACK FOOTER //
// ./src/app/main/search/search-results-tiles.js